import { Injectable } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { GlobalService } from "app/global/global.service";
import {
  GenerationError,
  DocumentGenerationService,
  DocumentGenerationEvent,
} from "app/global/AI-generation";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslocoService } from "@jsverse/transloco";
import { take } from "rxjs";
import { type IGenerationService } from "../general-modals/generate-from-document-or-prompt/generate-from-document-or-prompt-modal.component";

@Injectable({ providedIn: "root" })
export class GenerateDocumentModalService implements IGenerationService {
  constructor(
    private router: Router,
    private documentGenerationService: DocumentGenerationService,
    private _translocoService: TranslocoService,
    private globalService: GlobalService,
    public modalService: NgbActiveModal,
    private fb: FormBuilder,
  ) {}

  generateFromDocument(
    file: File,
    prompt: string,
    option: { name: string; value: "template_document" | "regular" },
  ): void {
    this.generateDocument({ file, prompt, documentType: option.value });
  }

  generateFromScratch(
    prompt: string,
    option: { name: string; value: "template_document" | "regular" },
  ): void {
    this.generateDocument({
      file: undefined,
      prompt,
      documentType: option.value,
    });
  }

  handleGenerationStarts(documentId: string) {
    this.router.navigateByUrl(`/send-document/${documentId}`);
  }

  handleGenerationError({ subject }: { subject: GenerationError }) {
    if (GenerationError.ALREADY_RUN === subject) {
      this.globalService.toastrError(
        this._translocoService.translate(
          "Already generating error (AI template generation modal) - You are already generating a template",
        ),
      );
    }
  }

  dispatchCallbackByEvent(event: DocumentGenerationEvent) {
    switch (event.status) {
      case "start":
        this.handleGenerationStarts(event.data.data.documentId);
        break;
      case "error":
        this.handleGenerationError(event.data);
        break;
    }
  }

  generateDocument({
    file,
    prompt,
    documentType,
  }: {
    file?: File;
    prompt?: string;
    documentType: "template_document" | "regular";
  }) {
    this.documentGenerationService
      .generate(documentType, file, prompt)
      .pipe(take(1))
      .subscribe((event) => this.dispatchCallbackByEvent(event));
    this.modalService.close();
  }
}
